export default __webpack_public_path__ + "static/media/2344.9272e4f8.png";